import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import weather from '@/views/weather.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'weather',
    component: weather
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
